import { render } from "./JDatatableBuilderSvg.vue?vue&type=template&id=1855816e"
import script from "./JDatatableBuilderSvg.vue?vue&type=script&lang=js"
export * from "./JDatatableBuilderSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__